<script setup></script>

<template>
  <div class="h-44 bg-black"></div>
</template>

<style scoped></style>
